import { FC, ReactNode } from 'react';

import ConstructionIcon from '@mui/icons-material/Construction';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import Divider from '@mui/material/Divider';
import GridCard from 'components/GridCard';

type Props = {
  icon?: ReactNode;
  title: string;
  description?: string;
  action: ReactNode;
};

const ToolCard: FC<Props> = ({ icon, title, description, action }) => (
  <GridCard
    sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
    }}>
    <CardMedia
      sx={{
        minHeight: 75,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'text.secondary',
      }}>
      {icon ?? <ConstructionIcon fontSize="large" />}
    </CardMedia>

    <Divider variant="middle" />

    <CardContent sx={{ flexGrow: 1 }}>
      <Typography gutterBottom variant="h5" component="div">
        {title}
      </Typography>

      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </CardContent>

    <CardActions>{action}</CardActions>
  </GridCard>
);

export default ToolCard;
